<div class="py-1 ap-filter">
	<div class="filter_head flex justify-between items-center">
		<h3 class="uppercase font-medium text-[0.9rem]">{{ control.name }}</h3>
		<div (click)="toggleCollapse()">
			<span *ngIf="collapse" class="cursor-pointer">
				<span class="plus_minus_icon plus material-symbols-outlined">add</span>
			</span>
			<span *ngIf="!collapse" class="cursor-pointer">
				<span class="plus_minus_icon plus material-symbols-outlined">remove</span>
			</span>
		</div>
	</div>
	<div  [ngClass]="collapse ? 'filter_option_inner' : 'filter_option_inner active'">
		<div [ngClass]="collapse ? 'ap-filter-tree-items-hidden' : ''" class="ap-filter-cc ap-filter-tree-items">
			<mat-checkbox (change)="onChange()" *ngFor="let item of control.options" [(ngModel)]="item.activated"
				[checked]="item.activated" [ngClass]="collapse ? 'ap-filter-checkbox-hide' : ''"
				class="ap-filter-checkbox text-base mx-1">
				<div class="flex items-center">
					<div class="ap-filter-swatch" [ngStyle]="{backgroundColor: item.colorCode}"></div>
					<span class="uppercase ap-filter-header">{{ item.name }}</span>
				</div>
			</mat-checkbox>
		</div>
	</div>
</div>
